import Model from "./base/model";

class SimulationValueAdd extends Model {
  resourceName() {
    return "simulation_values_add";
  }

  fields() {
    return {
      simulation_value_id: "",
      description_add: "",
      type: "",
      value: "",
      when_add: "",

      simulation_value: {jsonApi: "hasOne", type: "simulation_values"},

    };
  }
}

export default new SimulationValueAdd();
